import { ArrowRight2 } from "iconsax-reactjs";
import React from "react";

type MoreButtonProps = {
  title: string;
};

function MoreButton({ title }: MoreButtonProps) {
  return (
    <div className="flex items-center">
      <span className="actor-regular text-[#EEB762] text-base mr-4">
        {title}
      </span>
      <ArrowRight2 size="13" color="#EEB762" />
    </div>
  );
}

export default MoreButton;
